import React from "react";
import { RaisedButton } from "material-ui";
import { Link } from "react-router";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import UserStore from "../stores/UserStore";

import LinkLike from "./partials/link-like.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";

class Analytics extends React.Component {
  static getStores() {
    return [EventBucketStore, UserStore];
  }

  static getPropsFromStores() {
    return {
      getEventBucketById: EventBucketStore.getEventBucketById
    };
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  render() {
    const { eventBucketId } = this.props.params,
      eventBucket = this.props.getEventBucketById(eventBucketId);

    if (!eventBucket) {
      return <WorkingIndicator fullPage={true} />;
    }

    return (
      <div>
        <h1>"{eventBucket.name}" analytics</h1>
        <p>
          Use Eventive Analytics to learn more about your event bucket and
          attendees.
          <br />
          {UserStore.hasPermission("view_analytics") ? (
            <span>
              Looking for more? <Link to="/reports">Global reports</Link> are
              available as well.
            </span>
          ) : null}
        </p>
        {UserStore.hasPermission("view_analytics") ||
          UserStore.hasPermission("view_attendee_analytics") ? (
          <div>
            <RaisedButton
              label="Attendee analytics"
              primary={true}
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${eventBucketId}/analytics/attendees`
                )
              }
            />
          </div>
        ) : null}
        {UserStore.hasPermission("view_analytics") ||
          UserStore.hasPermission("view_event_analytics") ? (
          <div style={{ marginTop: 10 }}>
            <RaisedButton
              label="Event analytics"
              primary={true}
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${eventBucketId}/analytics/events`
                )
              }
            />
          </div>
        ) : null}
        {UserStore.hasPermission("view_analytics") ||
          UserStore.hasPermission("view_standalone_ticket_analytics") ? (
          <div style={{ marginTop: 10 }}>
            <RaisedButton
              label="Standalone ticket analytics"
              primary={true}
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${eventBucketId}/analytics/event_sales`
                )
              }
            />
          </div>
        ) : null}
        {UserStore.hasPermission("view_analytics") ||
          UserStore.hasPermission("view_pass_sales_analytics") ? (
          <div style={{ marginTop: 10 }}>
            <RaisedButton
              label="Pass sales analytics"
              primary={true}
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${eventBucketId}/analytics/passes`
                )
              }
            />
          </div>
        ) : null}
        {UserStore.hasPermission("view_analytics") ||
          UserStore.hasPermission("view_pass_ticket_analytics") ? (
          <div style={{ marginTop: 10 }}>
            <RaisedButton
              label="Pass ticket analytics"
              primary={true}
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${eventBucketId}/analytics/event_passes`
                )
              }
            />
          </div>
        ) : null}
        {UserStore.hasPermission("view_analytics") ||
          UserStore.hasPermission("view_recurring_pass_analytics") ? (
          <div style={{ marginTop: 10 }}>
            <RaisedButton
              label="Recurring pass analytics"
              primary={true}
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${eventBucketId}/analytics/recurring_pass`
                )
              }
            />
          </div>
        ) : null}
        {eventBucket.frontend_config.memberships_enabled &&
          (UserStore.hasPermission("view_analytics") ||
            UserStore.hasPermission("view_pass_sales_analytics")) ? (
          <div style={{ marginTop: 10 }}>
            <RaisedButton
              label="Membership sales analytics"
              primary={true}
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${eventBucketId}/analytics/memberships`
                )
              }
            />
          </div>
        ) : null}
        {eventBucket.frontend_config.memberships_enabled && (UserStore.hasPermission("view_analytics") ||
          UserStore.hasPermission("view_pass_ticket_analytics")) ? (
          <div style={{ marginTop: 10 }}>
            <RaisedButton
              label="Membership ticket analytics"
              primary={true}
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${eventBucketId}/analytics/event_memberships`
                )
              }
            />
          </div>
        ) : null}
        {eventBucket.frontend_config.memberships_enabled &&
          (UserStore.hasPermission("view_analytics") ||
            UserStore.hasPermission("view_recurring_pass_analytics")) ? (
          <div style={{ marginTop: 10 }}>
            <RaisedButton
              label="Membership status analytics"
              primary={true}
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${eventBucketId}/analytics/recurring_membership`
                )
              }
            />
          </div>
        ) : null}
        {UserStore.hasPermission("view_analytics") ||
          UserStore.hasPermission("view_geo_analytics") ? (
          <div style={{ marginTop: 10 }}>
            <RaisedButton
              label="Geo analytics"
              primary={true}
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${eventBucketId}/analytics/geo`
                )
              }
            />
          </div>
        ) : null}
        {UserStore.hasPermission("view_analytics") ||
          UserStore.hasPermission("view_streaming_analytics") ? (
          <div style={{ marginTop: 10 }}>
            <RaisedButton
              label="Streaming analytics"
              primary={true}
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${eventBucketId}/analytics/streaming`
                )
              }
            />
          </div>
        ) : null}
        {UserStore.hasPermission("view_analytics") ||
          UserStore.hasPermission("view_sales_analytics") ? (
          <div style={{ marginTop: 10 }}>
            <RaisedButton
              label="Sales analytics"
              primary={true}
              onTouchTap={() =>
                this.context.router.push(
                  `/event_buckets/${eventBucketId}/analytics/sales`
                )
              }
            />
          </div>
        ) : null}
        {UserStore.hasPermission("view_analytics") ||
          UserStore.hasPermission("view_discount_analytics") ? (
          <div style={{ marginTop: 10 }}>
            <RaisedButton label="Discount analytics" disabled={true} />
          </div>
        ) : null}
        {UserStore.hasPermission("view_analytics") ||
          UserStore.hasPermission("view_venue_analytics") ? (
          <div style={{ marginTop: 10 }}>
            <RaisedButton label="Venue analytics" disabled={true} />
          </div>
        ) : null}
        {UserStore.hasPermission("view_analytics") ? (
          <p>
            <i>
              Additional analytics functionality available soon.{" "}
              <LinkLike
                onTouchTap={() =>
                  Intercom("showNewMessage", "I'm looking to analyze: ")
                }
              >
                Tell us what you're looking for!
              </LinkLike>
            </i>
          </p>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(Analytics);



// WEBPACK FOOTER //
// ./src/app/components/analytics.jsx